.header,
.borderHeader {
	padding: 0 calc(var(--jpo-common-base-spacing) * 2);
}

.borderHeader {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
}

.actionWrapper {
	display: flex;
	flex-shrink: 0;
	gap: var(--jpo-common-base-spacing);
}
